/**
 * CompletionBar - Smart Set completion percentage indicator
 * IMPL-FEATURE2-SMARTSETS-20260204
 */
import React from 'react';

export default function CompletionBar({ percentage = 0, owned = 0, total = 0, size = 'md' }) {
  const pct = Math.min(100, Math.max(0, percentage));

  // Color based on completion level
  const getBarColor = () => {
    if (pct >= 100) return 'bg-green-500';
    if (pct >= 75) return 'bg-emerald-500';
    if (pct >= 50) return 'bg-yellow-500';
    if (pct >= 25) return 'bg-orange-500';
    return 'bg-red-500';
  };

  const heights = {
    sm: 'h-1',
    md: 'h-2',
    lg: 'h-3',
  };

  return (
    <div className="w-full">
      <div className={`w-full bg-zinc-800 rounded-full overflow-hidden ${heights[size] || heights.md}`}>
        <div
          className={`h-full ${getBarColor()} transition-all duration-500 rounded-full`}
          style={{ width: `${pct}%` }}
        />
      </div>
      {total > 0 && (
        <div className="flex justify-between mt-1">
          <span className="text-[10px] text-zinc-500">{owned}/{total} owned</span>
          <span className="text-[10px] text-zinc-400 font-medium">{pct.toFixed(1)}%</span>
        </div>
      )}
    </div>
  );
}
